<template>
  <AgGridRenderList
    :columnDefs="columnDefs"
    :rowData="rowData"
    :totalRows="totalRows"
    :lastPage="lastPage"
    :loading="paginationLoading"
    @updatePagination="updatePagination"
    @updateItemPerPage="updateItemPerPage"
  />
</template>

<script>
import General from "../../../../../../Mixins/general";
import moment from "moment-jalaali";

export default {
  components: {},
  props: {
    callRefresh: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    saveReturn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      status: null,
      columnDefs: null,
      rowData: null,
      totalRows: null,
      lastPage: null,
      invoiceIds: null,
      filterDialog: false,
      toDate: null,
      optionsNew: {
        page: 1,
        itemsPerPage: 10,
      },
      account: null,
      sellStatus: null,
      currencyFilter: null,
      fromAmount: null,
      fromNumber: null,
      fromDate: null,
      toAmount: null,
      toNumber: null,
      toDate: null,
      tag: null,
      category: null,
      branch: null,
      entrepot: null,
      lockStatus: null,
      registerar: null,
      payedStatus: null,
      fromTime: null,
      toTime: null,
      customFields: null,
      paginationLoading: false,
    };
  },
  mixins: [General],
  mounted() {
    this.columnDefs = [
      {
        headerName: "",
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 50,
        maxWidth: 50,
        minWidth: 50,
        cellRenderer: "AgVMenu",
        cellRendererParams: (params) => ({
          items: [
            {
              label: this.$t("calc_"),
              icon: "mdi-alert-circle",
              iconColor: "gray",
              action: (rowData) => this.openDialog(rowData),
            },
            {
              label: this.$t("delete"),
              icon: "mdi-trash-can-outline",
              iconColor: "gray",
              action: (rowData) => this.deleteAction(rowData),
            },
          ],
        }),
        resizable: false,
        pinned: "right",
      },
      {
        headerName: "#",
        colId: "rowNumber",
        valueGetter: (params) => params.node.rowIndex + 1,
        width: 70,
        maxWidth: 70,
        minWidth: 70,
        resizable: false,
        pinned: "right",
      },
      {
        headerName: this.$t("name") + " " + this.$t("personel"),
        field: "name",
        valueGetter: (params) => {
          if (
            params.data &&
            params.data.configs.name &&
            params.data.configs.name !== null
          ) {
            return params.data.configs.name;
          } else {
            return this.$t("haveNot");
          }
        },
        width: 150,
        minWidth: 150,
        sortable: true,
      },
      {
        headerName: this.$t("personnelCode"),
        field: "hrm_employee_id",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (
            params.data &&
            params.data.hrm_employee_id &&
            params.data.hrm_employee_id !== null
          ) {
            return params.data.hrm_employee_id;
          } else {
            return this.$t("haveNot");
          }
        },
        width: 130,
        minWidth: 130,
        sortable: true,
      },
      {
        headerName: this.$t("national-code") + " " + this.$t("personel"),
        field: "national_code",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (
            params.data &&
            params.data?.employee?.user &&
            params.data?.employee?.user !== null
          ) {
            return params.data?.employee?.user.national_code;
          } else {
            return this.$t("haveNot");
          }
        },
        width: 200,
        minWidth: 200,
        sortable: true,
      },
      {
        headerName: this.$t("performance_"),
        field: "daily_work",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data.daily_work && params.data.daily_work !== null) {
            return params.data.daily_work;
          } else {
            return this.$t("haveNot");
          }
        },
        width: 200,
        minWidth: 200,
        sortable: true,
      },
      {
        headerName: this.$t("benefit"),
        field: "benefit",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data.benefit && params.data.benefit !== null) {
            return this.$numberFormat(params.data.benefit);
          } else {
            return this.$t("haveNot");
          }
        },
        width: 200,
        minWidth: 200,
        sortable: true,
      },
      {
        headerName: this.$t("deductions"),
        field: "deductions",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (params.data) {
            const deduction = Number(params.data.deductions) || 0;
            // const tax = Number(params.data.tax) || 0;
            // const insurance = Number(params.data.employee_insurance) || 0;
            // const res = deduction + tax + insurance;
            return this.$numberFormat(deduction);
          } else {
            return this.$t("haveNot");
          }
        },
        width: 200,
        minWidth: 200,
        sortable: true,
      },
      {
        headerName: this.$t("insured’s_premium_share"),
        field: "employee_insurance",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (
            params.data &&
            params.data.employee_insurance &&
            params.data.employee_insurance !== null
          ) {
            return this.$numberFormat(params.data.employee_insurance);
          } else {
            return this.$t("haveNot");
          }
        },
        width: 200,
        minWidth: 200,
        sortable: true,
      },
      {
        headerName: this.$t("tax"),
        field: "tax",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data.tax && params.data.tax !== null) {
            return this.$numberFormat(params.data.tax);
          } else {
            return this.$t("haveNot");
          }
        },
        width: 200,
        minWidth: 200,
        sortable: true,
      },
      {
        headerName: this.$t("netPay"),
        field: "netpay",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          if (params.data) {
            const deduction = Number(params.data.deductions) || 0;
            const tax = Number(params.data.tax) || 0;
            const insurance = Number(params.data.employee_insurance) || 0;
            const total = deduction + tax + insurance;
            const peyment = params.data.benefit;
            const res = peyment - total;
            return this.$numberFormat(res);
          } else {
            return this.$t("haveNot");
          }
        },
        width: 200,
        minWidth: 200,
        sortable: true,
      },
    ];
  },
  watch: {
    callRefresh: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.getItems();
          this.$emit("initial-Loading-is", false);
        }
      },
    },
    saveReturn: {
      deep: true,
      handler(newVal) {
        if (newVal == true) {
          this.approvalSalery();
        }
      },
    },
    status: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.getItems();
        }
      },
    },
  },
  beforeMount() {
    this.getItems();
  },
  methods: {
    generateTime(val) {
      let format = "jYYYY/jMM/jDD";
      let date = val;
      if (!date) return null;
      return moment(date).locale("fa").format(format);
    },
    getItems(isPaginate = false) {
      var app = this;
      if (!isPaginate) {
        app.$emit("initial-Loading-is", true);
      }
      const id_ = app.$route.query.id;
      this.paginationLoading = isPaginate;
      app.$axios
        .get(app.$endpoint + "salary/employee-list/" + id_, {
          params: {
            options: app.optionsNew,
          },
        })
        .then((response) => {
          app.status = response.data?.salaries?.data[0].status;
          if (app.status == "done") {
            this.approvalSalery();
          } else {
            app.rowData = [...response.data.salaries.data];
            app.totalRows = response.data.salaries.total;
            app.lastPage = response.data.salaries.last_page;
            app.$emit("salary-factor-items", {
              items: response.data,
            });
          }
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.$emit("initial-Loading-is", false);
          app.$emit("call-refresh");
          app.paginationLoading = false;
        });
    },
    refreshData() {
      this.getItems(true);
    },
    updatePagination(value) {
      this.optionsNew.page = value;
      this.getItems(true);
    },
    approvalSalery() {
      var app = this;
      app.loading = true;
      const id_ = app.$route.query.id ? app.$route.query.id : 0;
      let changeStatus;
      if (app.status == "pending") {
        changeStatus = "done";
      } else if (app.status == "done") {
        changeStatus = "pending";
      }
      app.$axios
        .put(this.$endpoint + "salary/update-status/" + id_, {
          status: changeStatus,
        })
        .then((response) => {
          if (changeStatus == "done") {
            this.$router.push({
              name: "salery_operations",
            });
          } else {
            this.getItems();
          }
        })
        .catch((err) => {
          app.loading = false;
          app.$emit("again-ready-to-save");
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.$emit("again-ready-to-save");
          app.$emit("is-loading", false);
          app.loading = false;
        });
    },
    updateItemPerPage(value) {
      this.optionsNew.itemsPerPage = value;
      this.optionsNew.page = 1;
      this.getItems(true);
    },
    editAction(rowData) {
      this.$router.push({
        name: "edit_salery_factors",
        params: { id: rowData.id, tabName: rowData.id },
      });
    },
    deleteAction(rowData) {
      var app = this;
      let salaryFactorConfigId = rowData.id;
      app.$axios
        .delete(app.$endpoint + "salary-factor-config/" + salaryFactorConfigId)
        .then((response) => {})
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          this.getItems(true);
          app.paginationLoading = false;
        });
    },
    openDialog(rowData) {
      let selectedRowData = rowData;
      this.$emit("open-calc-dialog", selectedRowData);
    },
  },
};
</script>

<style>
.wrapperTable {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.v-skeleton-loader__list-item.v-skeleton-loader__bone {
  align-content: unset;
  align-items: flex-start;
  padding: 0;
}
.theme--light.v-skeleton-loader .v-skeleton-loader__text {
  background: rgb(146 139 139 / 12%);
}
.v-skeleton-loader__text {
  height: 30px;
}
.v-skeleton-loader__list-item {
  height: 41px;
}
</style>
